module.exports = __webpack_public_path__ + "img/icon-fail.a748c0bc.svg";